import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {PlanRessurs} from "felles/tjenester/ressurser/PlanRessurs";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {RedigerPlanDialog} from "../../modale/redigerPlanDialog/redigerPlanDialog";

const css = require('./plan.scss');

export class PlanKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmGruppePlan', {
              bindings: {plan: '<'},
              controller: PlanKontroller.forInjisering(),
              template: require('./plan.html')
          });
    }

    static forInjisering() {
        return [
            PlanRessurs.regNavn,
            RedigerPlanDialog.regNavn,
            PlanKontroller
        ]
    }

    constructor(private planRes: PlanRessurs,
                private redigerPlanDialog: RedigerPlanDialog) {
    }

    plan: l.PlanModell; //settes via bindings/$onChanges
    redigerFoersteNummerMulig: boolean;

    $onChanges(changes: IOnChangesObject): void {
        dersomChangesInneholder(changes, 'plan',
          (plan: l.PlanModell) => {
              this.initPlan(plan);
          })
    }

    private initPlan(plan: l.PlanModell) {
        this.plan = plan;
        this.redigerFoersteNummerMulig = true;
        this.plan.moeter.forEach((moete) => {
            if (moete.laastForRedigering) this.redigerFoersteNummerMulig = false;
        });
    }

    redigerFoersteNummer() {
        this.redigerPlanDialog.visRedigerPlanDialog(this.plan);
    }
}

